// extracted by mini-css-extract-plugin
export default {"EmptyError":"EmptyError_EmptyError__ccPKu","icon":"EmptyError_icon__H1CQa"};